import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import isEmpty from 'lodash/isEmpty';
import omitBy from 'lodash/omitBy';

/* List of Promotions created by a Partner */
export const getPromotions = (mpacBaseUrl, partnerId, searchParams) => {
  // URLSearchParams expects all params to be a string
  const stringifiedParams = {};
  Object.keys(searchParams).map(key => stringifiedParams[key] = searchParams[key] ? searchParams[key].toString() : '');
  const params = new URLSearchParams(omitBy(stringifiedParams, isEmpty));
  return fetchOk("".concat(mpacBaseUrl, "/gateway/api/marketplace/catalog/partners/").concat(partnerId, "/promotions/paged?").concat(params.toString())).then(response => response.json());
};
/* Create Promotion by a Partner*/

export const createPromotion = (mpacBaseUrl, partnerId, promotion) => fetchOk("".concat(mpacBaseUrl, "/gateway/api/marketplace/catalog/partners/").concat(partnerId, "/promotions"), {
  method: 'POST',
  body: JSON.stringify(promotion),
  headers: {
    'Content-Type': 'application/json'
  }
}).then(response => response.json());
/* Update Promotion created by a Partner*/

export const updatePromotion = (mpacBaseUrl, partnerId, promotionId, promotion) => fetchOk("".concat(mpacBaseUrl, "/gateway/api/marketplace/catalog/partners/").concat(partnerId, "/promotions/").concat(promotionId), {
  method: 'PATCH',
  body: JSON.stringify(promotion),
  headers: {
    'Content-Type': 'application/json'
  }
}).then(response => response.json());
/* Promotion Details created by a Partner*/

export const getPromotionDetails = (mpacBaseUrl, partnerId, promotionId) => fetchOk("".concat(mpacBaseUrl, "/gateway/api/marketplace/catalog/partners/").concat(partnerId, "/promotions/").concat(promotionId)).then(response => response.json());
/* List of Promotion Codes created by a Partner*/

export const getPromotionCodes = (mpacBaseUrl, partnerId, promotionId) => fetchOk("".concat(mpacBaseUrl, "/gateway/api/marketplace/catalog/partners/").concat(partnerId, "/promotions/").concat(promotionId, "/codes")).then(response => response.json()).then(response => response.codes);
/* Create Promotion Code created by a Partner*/

export const createPromotionCode = (mpacBaseUrl, partnerId, promotionId) => fetchOk("".concat(mpacBaseUrl, "/gateway/api/marketplace/catalog/partners/").concat(partnerId, "/promotions/").concat(promotionId, "/codes"), {
  method: 'POST'
}).then(response => response.json());
/* Delete Promotion Code created by a Partner*/

export const deletePromotionCode = (mpacBaseUrl, partnerId, promotionId, promotionCode) => fetchOk("".concat(mpacBaseUrl, "/gateway/api/marketplace/catalog/partners/").concat(partnerId, "/promotions/").concat(promotionId, "/codes/").concat(promotionCode), {
  method: 'DELETE'
}).then(response => response.json()); // End promotion created by partner

export const endPromotion = (mpacBaseUrl, partnerId, promotionId) => fetchOk("".concat(mpacBaseUrl, "/gateway/api/marketplace/catalog/partners/").concat(partnerId, "/promotions/").concat(promotionId, "/end"), {
  method: 'PATCH'
}).then(response => response.json());